import { render, staticRenderFns } from "./BusinessApplicationPriceApply.vue?vue&type=template&id=14d5fc82&scoped=true"
import script from "./BusinessApplicationPriceApply.vue?vue&type=script&lang=js"
export * from "./BusinessApplicationPriceApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d5fc82",
  null
  
)

export default component.exports